<!-- src/components/Callback.vue -->
<template>
    <div>Loading...
      Logged In
    </div>
    
  </template>
  
  <script>
  export default {
    name:'callback-page',
    async mounted() {
      try {
        await this.$auth.handleAuthentication();
        this.$router.push('/');
      } catch (e) {
        console.error(e);
        this.$router.push('/');
      }
    }
  };
  </script>
  